module.exports = __webpack_public_path__ + "static/media/origin-orange.732e9598.svg";